import React, { Component } from 'react';

import {ToolTip,Icon,SiteModifier,Link,LoaderLink,Loader,Window,Media,Section,Content,ModifierSection} from '../_core/components';
import {Template} from '../_core/controllers';
import {Data} from '../_core/models';

import settings from '../_settings';

import {Breakpoints} from '../_core/utils';

// Project
import * as Project from '../components';

class Layout extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}

	/*

		RENDER

	*/

	render() {


		return (

		<Data>
			{({ENTRY,navigation,entries,background,globals})=>{

				// Set background colour stored in data
				let style = null;
				if(background){

					style ={background:background};

				}

			return (
			<div className="Site-page" style={style}>
              <div className="Site-logo">
                <div><LoaderLink to={'/'} deactivate="#nav">{settings.SITENAME}</LoaderLink></div>
              </div>

              <SiteModifier toggle={'menu'}>
              	<div className="Site-burger">
              		<span className="Site-burger-line Site-burger-line--top" />
              		<span className="Site-burger-line Site-burger-line--middle" />
              		<span className="Site-burger-line Site-burger-line--bottom" />
              		<span className="Site-burger-line Site-burger-line--x1" />
              		<span className="Site-burger-line Site-burger-line--x2" />
              	</div>
              </SiteModifier>

              <div className="Site-home">
                <Link to={'/'}><img className="light" src="/ui/img/home-light.svg" /><img className="dark" src="/ui/img/home.svg" /></Link>
              </div>

              <div className="Site-nav">
              	<div className="Container Container--nav">
              		<SiteModifier demodifier={'menu'}>
	                <ul className="List List--nav" id="nav">
                      <li>
                        <Content modifier="article">
                          <h3>Pick a film</h3>
                        </Content>
                      </li>
	                  {navigation.main.map(entry=>(
	                    <li key={entry.id}><LoaderLink to={entry.uri} navlink exact={true} deactivate="#nav">{entry.title}</LoaderLink></li>
	                  ))}
	                </ul>
	                </SiteModifier>

	                <div className="Site-contact">
	                	<ul className="List List--icons">
		                  <li><a href={globals.mapLink} target="_blank"><Icon type={'map'} /></a></li>
		                  <li><a href={'mailto:'+globals.email}><Icon type={'email'} /></a></li>
		                  <li><a href={'tel:'+globals.telephone}><Icon type={'telephone'} /></a></li>
		                </ul>
	                </div>
                </div>
              </div>

              <div className="Site-template">
              	<Data ignore={['feature']}>
              	 {()=>(
              	 	<Template />
              	 )}
              	</Data>
              </div>

              <div className="Site-foot">
                <Content modifier="credit">
                  <p>Site by: <a href="https://studiomm.co.uk/" target="_blank">StudioMM</a> | <a href="https://www.aenetworks.com/terms" target="_blank">Terms of use</a> | <a href="https://www.aenetworks.com/copyright" target="_blank">Copyright policy</a> | <a href="https://www.aenetworks.com/privacy-lifetime-behind-the-scenes/">Privacy</a></p>
                </Content>
              </div>

              <ToolTip className="Site-tooltip">
              	<Data>
              		{({feature,lastFeature})=>{

              			if(feature){
              				return (
              					<div>
              						<SiteModifier modifier={'showToolTip'} />
              					
              						<Media id={feature} fluid={false} />
              					</div>
              				)
              			}else{
              				return (
              					<div>
              						<SiteModifier demodifier={'showToolTip'} />
              					
              						<Media id={lastFeature} fluid={false} />
              					</div>
              				)
              			}

              		}}
              	</Data>
              </ToolTip>

            </div>
          )}}
		</Data>


		);

	}
}

export default Layout;



// WEBPACK FOOTER //
// ./src/js/templates/_layout.js